import { type AuthResponseData, removeTokens, setTokens } from "@shapr3d/frontend-lib";
import queryString from "query-string";

import { remoteConfigReactClient } from "../components/App/components/AppProviders";
import { trackingAdapter } from "../lib/TrackingAdapter";
import { SearchParam, type SignupSource } from "../types";

export const saveLoggedInUser = ({ refreshToken, accessToken, id }: AuthResponseData) => {
  setTokens(refreshToken, accessToken);
  trackingAdapter.setUserData({ userID: id });
  remoteConfigReactClient?.setIsLoading(true);
};

export const logoutAndRedirectToLogin = () => {
  const tracker = trackingAdapter;
  tracker.reset();

  removeTokens();

  const url = queryString.stringifyUrl({
    url: "/login",
    query: {
      [SearchParam.RedirectUrl]: encodeURIComponent(window.location.href),
    },
  });
  window.location.replace(url);
};

export const navigateToAuth = ({
  shouldRelogin,
  authHint,
  emailHint,
  signupSource,
}: {
  shouldRelogin?: boolean;
  authHint?: "signup" | "login";
  emailHint?: string;
  signupSource?: SignupSource;
} = {}) => {
  if (shouldRelogin) {
    const tracker = trackingAdapter;
    tracker.reset();
    removeTokens();
  }

  const authURL = new URL(
    `${window.location.origin}/${authHint ?? "login"}?redirect_url=${encodeURIComponent(window.location.href)}`
  );
  if (authHint) {
    authURL.searchParams.append(SearchParam.AuthHint, authHint);
  }
  if (signupSource && authHint === "signup") {
    authURL.searchParams.append(SearchParam.SignupSource, signupSource);
  }
  const hashParams = new URLSearchParams();
  if (emailHint) {
    hashParams.append(SearchParam.EmailHint, emailHint);
  }
  authURL.hash = hashParams.toString();

  window.location.assign(authURL.toString());
};
